export const enum MenuItemType {
    Wineries = 'Wineries',
    Appellations = 'Appellations',
    Classifications = 'Classifications',
    RedVarieties = 'Red Varieties',
    WhiteVarieties = 'White Varieties',
    Subregions = 'Subregions',
    Regions = 'Regions',
    Countries = 'Countries',
    Continents = 'Continents'
}



// WEBPACK FOOTER //
// ./src/model/menuItems.ts